import { useState } from "react";
import { motion } from "framer-motion";
import { Box, Typography } from '@mui/material';
import "./DesktopMenu.css";
import { hasPermission } from '../../context/AuthFunc';

export default function DesktopMenu({ menu }) {
  const [isHover, toggleHover] = useState(false);
  const toggleEnter = () => {
    toggleHover(true);
  };
  const toggleExit = () => {
    toggleHover(false);
  }

  const subMenuAnimate = {
    enter: {
      opacity: 1,
      rotateX: 0,
      transition: {
        duration: 0.2,
      },
      display: "block",
    },
    exit: {
      opacity: 0,
      rotateX: -15,
      transition: {
        duration: 0,
      },
      transitionEnd: {
        display: "none",
      },
    },
  };

  const hasSubMenu = menu?.subMenu?.length;

  return (
    <Box
      component={motion.div}
      sx={{
        position: 'relative',
        display: 'inline-block'
      }}
      onHoverStart={toggleEnter}
      onHoverEnd={toggleExit}
      key={menu.name}
    >
      <Typography 
        component="span"
        sx={{
          fontSize: "20px",
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          cursor: 'pointer',
          px: 2,
          py: 1,
          color: 'inherit',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.08)'
          }
        }}
      >
        {menu.name}
      </Typography>
      {hasSubMenu && (
        <Box
          component={motion.div}
          initial="exit"
          animate={isHover ? "enter" : "exit"}
          variants={subMenuAnimate}
          sx={{
            position: 'absolute',
            backgroundColor: 'background.paper',
            borderRadius: 1,
            boxShadow: 3,
            zIndex: 1200,
            minWidth: 300
          }}
        >
          <Box sx={{
            display: "flex",
            flexDirection: "column"
          }}>
            {hasSubMenu &&
              menu.subMenu.map((submenu, i) => (
                hasPermission(submenu.permission) ? (
                <Box key={i}>
                  {menu.gridCols > 1 && menu?.subMenuHeading?.[i] && (
                    <Typography variant="caption" color="text.secondary" sx={{ mb: 2 }}>
                      {menu?.subMenuHeading?.[i]}
                    </Typography>
                  )}
                  <Box 
                    component="a" 
                    href={submenu.link}
                    sx={{
                      display: 'block',
                      p: 1,
                      px: 2,
                      borderRadius: 1,
                      textDecoration: 'none',
                      color: 'text.primary',
                      '&:hover': {
                        backgroundColor: 'action.hover'
                      }
                    }}
                  >
                    <Typography variant="subtitle1" fontWeight="medium">
                      {submenu.name}
                    </Typography>
                  </Box>
                </Box>
              ) : (<div></div>)
              ))}
          </Box>
        </Box>
      )}
    </Box>
  );
}
